import { extraNetworkActionsCreator } from '../../../../admincore'

const actions = {
  ...extraNetworkActionsCreator('UPDATE', 'invites/update'),
}

export default actions

export function update(id, params) {
  return {
    type: actions.UPDATE,
    payload: {
      id,
      params,
    },
  }
}

export function reset() {
  return {
    type: actions.RESET,
  }
}
